import React, { useEffect, useState } from "react";
import { Box, Button, Typography, Modal, TextField, FormGroup, FormControlLabel, Checkbox } from "@mui/material";
import axios from "axios";
import { url } from "../../../utils/url";

const AdminDrivers = () => {
  const [users, setUsers] = useState([]);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);
  const [newUser, setNewUser] = useState({
    username: "",
    password: "",
    userRoleId: 2,
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  });

  useEffect(() => {
    (async () => {
      try {
        const request = await axios.get(`${url}users?isActive=true`, { withCredentials: true });
        setUsers(request.data);
      } catch (err) {
        setError("Възникна проблем! Моля опитайте по-късно");
        console.log(err);
      }
    })();
  }, []);

  const addUserHandler = async () => {
    try {
      setError(null);
      await axios.post(
        `${url}users`,
        {
          username: newUser.username,
          password: newUser.password,
          userRoleId: newUser.userRoleId,
          firstName: newUser.firstName,
          lastName: newUser.lastName,
          email: newUser.email,
          phone: newUser.phone,
          isActive: true,
        },
        { withCredentials: true }
      );
      const request = await axios.get(`${url}users?isActive=true`, { withCredentials: true });
      setUsers(request.data);
    } catch (err) {
      setError("Възникна проблем! Моля опитайте по-късно");
      return;
    }

    setNewUser({
      username: "",
      password: "",
      userRoleId: 2,
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
    });
    setOpen(false);
  };

  const deleteUserHandler = async (user) => {
    setError(null);
    const userRemoval = { ...user, password: "123", isActive: false };
    try {
      await axios.put(`${url}users/${user.id}`, userRemoval, { withCredentials: true });
      const request = await axios.get(`${url}users?isActive=true`, { withCredentials: true });
      setUsers(request.data);
    } catch (err) {
      setError("Възникна проблем! Моля опитайте по-късно");
      console.log(err);
      return;
    }
  };

  const isButtonEnabled = () => {
    return (
      newUser.username.length >= 4 &&
      newUser.password.length >= 4 &&
      newUser.firstName.length >= 3 &&
      newUser.lastName.length >= 3 &&
      newUser.phone.match(/0\d{3}[ -]?\d{3}[ -]?\d{3}/)
    );
  };

  return (
    <Box>
      <Button variant="contained" sx={{ display: "block", margin: "auto" }} onClick={() => setOpen(true)}>
        Нов Потребител
      </Button>
      {error && (
        <Typography color="red" align="center">
          {error}
        </Typography>
      )}
      <Box
        sx={{
          display: {
            xs: "flex",
            lg: "grid",
          },
          flexDirection: "column",
          gridTemplateColumns: "1fr 1fr 1fr",
          gridGap: "30px",
          padding: "30px",
        }}
      >
        <Modal open={open} onClose={() => setOpen(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              borderRadius: "10px",
              boxShadow: 24,
              padding: "20px",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              gap: {
                xs: '7px',
                lg: "12px"
              },
            }}
          >
            <Button
              variant="text"
              sx={{
                color: "black",
                alignSelf: "flex-end",
                padding: 0,
                minWidth: "10px",
              }}
              onClick={() => setOpen(false)}
            >
              X
            </Button>
            <Typography variant="h6" component="h2">
              Добавяне на нов потребител
            </Typography>
            {error && (
              <Typography color="red" align="center">
                {error}
              </Typography>
            )}
            <TextField size="small" label="Потребителско име" onChange={(e) => setNewUser({ ...newUser, username: e.target.value })} value={newUser.username} />
            <TextField size="small" label="Парола" onChange={(e) => setNewUser({ ...newUser, password: e.target.value })} value={newUser.password} />
            <TextField size="small" label="Име" onChange={(e) => setNewUser({ ...newUser, firstName: e.target.value })} value={newUser.firstName} />
            <TextField size="small" label="Фамилия" onChange={(e) => setNewUser({ ...newUser, lastName: e.target.value })} value={newUser.lastName} />
            <TextField size="small" label="Имейл" onChange={(e) => setNewUser({ ...newUser, email: e.target.value })} value={newUser.email} />
            <TextField size="small" label="Телефон" onChange={(e) => setNewUser({ ...newUser, phone: e.target.value })} value={newUser.phone} />
            <FormGroup>
              <FormControlLabel
                control={<Checkbox size="small" checked={newUser.userRoleId === 1} onChange={() => setNewUser({ ...newUser, userRoleId: newUser.userRoleId === 2 ? 1 : 2 })} />}
                label="Създаване на нов Администратор"
              />
            </FormGroup>
            <Button variant="contained" onClick={addUserHandler} disabled={!isButtonEnabled()}>
              Добави
            </Button>
          </Box>
        </Modal>
        {users.map((user) => (
          <Box
            sx={{
              border: "1px solid black",
              borderRadius: "10px",
              padding: "10px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            key={user.id}
          >
            <Box>
              <Typography>Потребителско име: {user.username}</Typography>
              <Typography>
                Име: {user.firstName} {user.lastName}
              </Typography>
              <Typography>Имейл: {user.email}</Typography>
              <Typography>Телефон: {user.phone}</Typography>
              <Typography>Администраторски права: {user.userRoleId === 1 ? "Да" : "Не"}</Typography>
            </Box>
            <Button color="error" sx={{ alignSelf: "flex-start" }} onClick={() => deleteUserHandler(user)}>
              Изтрий
            </Button>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default AdminDrivers;
